export const geoList = [
  {id: 'geoTargetConstants/2004', value: 'Afghanistan'},
  {id: 'geoTargetConstants/2008', value: 'Albania'},
  {id: 'geoTargetConstants/2010', value: 'Antarctica'},
  {id: 'geoTargetConstants/2012', value: 'Algeria'},
  {id: 'geoTargetConstants/2016', value: 'American Samoa'},
  {id: 'geoTargetConstants/2020', value: 'Andorra'},
  {id: 'geoTargetConstants/2024', value: 'Angola'},
  {id: 'geoTargetConstants/2028', value: 'Antigua and Barbuda'},
  {id: 'geoTargetConstants/2031', value: 'Azerbaijan'},
  {id: 'geoTargetConstants/2032', value: 'Argentina'},
  {id: 'geoTargetConstants/2036', value: 'Australia'},
  {id: 'geoTargetConstants/2040', value: 'Austria'},
  {id: 'geoTargetConstants/2044', value: 'The Bahamas'},
  {id: 'geoTargetConstants/2048', value: 'Bahrain'},
  {id: 'geoTargetConstants/2050', value: 'Bangladesh'},
  {id: 'geoTargetConstants/2051', value: 'Armenia'},
  {id: 'geoTargetConstants/2052', value: 'Barbados'},
  {id: 'geoTargetConstants/2056', value: 'Belgium'},
  {id: 'geoTargetConstants/2064', value: 'Bhutan'},
  {id: 'geoTargetConstants/2068', value: 'Bolivia'},
  {id: 'geoTargetConstants/2070', value: 'Bosnia and Herzegovina'},
  {id: 'geoTargetConstants/2072', value: 'Botswana'},
  {id: 'geoTargetConstants/2076', value: 'Brazil'},
  {id: 'geoTargetConstants/2084', value: 'Belize'},
  {id: 'geoTargetConstants/2090', value: 'Solomon Islands'},
  {id: 'geoTargetConstants/2096', value: 'Brunei'},
  {id: 'geoTargetConstants/2100', value: 'Bulgaria'},
  {id: 'geoTargetConstants/2104', value: 'Myanmar (Burma)'},
  {id: 'geoTargetConstants/2108', value: 'Burundi'},
  {id: 'geoTargetConstants/2112', value: 'Belarus'},
  {id: 'geoTargetConstants/2116', value: 'Cambodia'},
  {id: 'geoTargetConstants/2120', value: 'Cameroon'},
  {id: 'geoTargetConstants/2124', value: 'Canada'},
  {id: 'geoTargetConstants/2132', value: 'Cabo Verde'},
  {id: 'geoTargetConstants/2140', value: 'Central African Republic'},
  {id: 'geoTargetConstants/2144', value: 'Sri Lanka'},
  {id: 'geoTargetConstants/2148', value: 'Chad'},
  {id: 'geoTargetConstants/2152', value: 'Chile'},
  {id: 'geoTargetConstants/2156', value: 'China'},
  {id: 'geoTargetConstants/2162', value: 'Christmas Island'},
  {id: 'geoTargetConstants/2166', value: 'Cocos (Keeling) Islands'},
  {id: 'geoTargetConstants/2170', value: 'Colombia'},
  {id: 'geoTargetConstants/2174', value: 'Comoros'},
  {id: 'geoTargetConstants/2178', value: 'Republic of the Congo'},
  {id: 'geoTargetConstants/2180', value: 'Democratic Republic of the Congo'},
  {id: 'geoTargetConstants/2184', value: 'Cook Islands'},
  {id: 'geoTargetConstants/2188', value: 'Costa Rica'},
  {id: 'geoTargetConstants/2191', value: 'Croatia'},
  {id: 'geoTargetConstants/2196', value: 'Cyprus'},
  {id: 'geoTargetConstants/2203', value: 'Czechia'},
  {id: 'geoTargetConstants/2204', value: 'Benin'},
  {id: 'geoTargetConstants/2208', value: 'Denmark'},
  {id: 'geoTargetConstants/2212', value: 'Dominica'},
  {id: 'geoTargetConstants/2214', value: 'Dominican Republic'},
  {id: 'geoTargetConstants/2218', value: 'Ecuador'},
  {id: 'geoTargetConstants/2222', value: 'El Salvador'},
  {id: 'geoTargetConstants/2226', value: 'Equatorial Guinea'},
  {id: 'geoTargetConstants/2231', value: 'Ethiopia'},
  {id: 'geoTargetConstants/2232', value: 'Eritrea'},
  {id: 'geoTargetConstants/2233', value: 'Estonia'},
  {
    id: 'geoTargetConstants/2239',
    value: 'South Georgia and the South Sandwich Islands',
  },
  {id: 'geoTargetConstants/2242', value: 'Fiji'},
  {id: 'geoTargetConstants/2246', value: 'Finland'},
  {id: 'geoTargetConstants/2250', value: 'France'},
  {id: 'geoTargetConstants/2258', value: 'French Polynesia'},
  {id: 'geoTargetConstants/2260', value: 'French Southern and Antarctic Lands'},
  {id: 'geoTargetConstants/2262', value: 'Djibouti'},
  {id: 'geoTargetConstants/2266', value: 'Gabon'},
  {id: 'geoTargetConstants/2268', value: 'Georgia'},
  {id: 'geoTargetConstants/2270', value: 'The Gambia'},
  {id: 'geoTargetConstants/2276', value: 'Germany'},
  {id: 'geoTargetConstants/2288', value: 'Ghana'},
  {id: 'geoTargetConstants/2296', value: 'Kiribati'},
  {id: 'geoTargetConstants/2300', value: 'Greece'},
  {id: 'geoTargetConstants/2308', value: 'Grenada'},
  {id: 'geoTargetConstants/2316', value: 'Guam'},
  {id: 'geoTargetConstants/2320', value: 'Guatemala'},
  {id: 'geoTargetConstants/2324', value: 'Guinea'},
  {id: 'geoTargetConstants/2328', value: 'Guyana'},
  {id: 'geoTargetConstants/2332', value: 'Haiti'},
  {id: 'geoTargetConstants/2334', value: 'Heard Island and McDonald Islands'},
  {id: 'geoTargetConstants/2336', value: 'Vatican City'},
  {id: 'geoTargetConstants/2340', value: 'Honduras'},
  {id: 'geoTargetConstants/2348', value: 'Hungary'},
  {id: 'geoTargetConstants/2352', value: 'Iceland'},
  {id: 'geoTargetConstants/2356', value: 'India'},
  {id: 'geoTargetConstants/2360', value: 'Indonesia'},
  {id: 'geoTargetConstants/2368', value: 'Iraq'},
  {id: 'geoTargetConstants/2372', value: 'Ireland'},
  {id: 'geoTargetConstants/2376', value: 'Israel'},
  {id: 'geoTargetConstants/2380', value: 'Italy'},
  {id: 'geoTargetConstants/2384', value: "Cote d'Ivoire"},
  {id: 'geoTargetConstants/2388', value: 'Jamaica'},
  {id: 'geoTargetConstants/2392', value: 'Japan'},
  {id: 'geoTargetConstants/2398', value: 'Kazakhstan'},
  {id: 'geoTargetConstants/2400', value: 'Jordan'},
  {id: 'geoTargetConstants/2404', value: 'Kenya'},
  {id: 'geoTargetConstants/2410', value: 'South Korea'},
  {id: 'geoTargetConstants/2414', value: 'Kuwait'},
  {id: 'geoTargetConstants/2417', value: 'Kyrgyzstan'},
  {id: 'geoTargetConstants/2418', value: 'Laos'},
  {id: 'geoTargetConstants/2422', value: 'Lebanon'},
  {id: 'geoTargetConstants/2426', value: 'Lesotho'},
  {id: 'geoTargetConstants/2428', value: 'Latvia'},
  {id: 'geoTargetConstants/2430', value: 'Liberia'},
  {id: 'geoTargetConstants/2434', value: 'Libya'},
  {id: 'geoTargetConstants/2438', value: 'Liechtenstein'},
  {id: 'geoTargetConstants/2440', value: 'Lithuania'},
  {id: 'geoTargetConstants/2442', value: 'Luxembourg'},
  {id: 'geoTargetConstants/2450', value: 'Madagascar'},
  {id: 'geoTargetConstants/2454', value: 'Malawi'},
  {id: 'geoTargetConstants/2458', value: 'Malaysia'},
  {id: 'geoTargetConstants/2462', value: 'Maldives'},
  {id: 'geoTargetConstants/2466', value: 'Mali'},
  {id: 'geoTargetConstants/2470', value: 'Malta'},
  {id: 'geoTargetConstants/2478', value: 'Mauritania'},
  {id: 'geoTargetConstants/2480', value: 'Mauritius'},
  {id: 'geoTargetConstants/2484', value: 'Mexico'},
  {id: 'geoTargetConstants/2492', value: 'Monaco'},
  {id: 'geoTargetConstants/2496', value: 'Mongolia'},
  {id: 'geoTargetConstants/2498', value: 'Moldova'},
  {id: 'geoTargetConstants/2499', value: 'Montenegro'},
  {id: 'geoTargetConstants/2504', value: 'Morocco'},
  {id: 'geoTargetConstants/2508', value: 'Mozambique'},
  {id: 'geoTargetConstants/2512', value: 'Oman'},
  {id: 'geoTargetConstants/2516', value: 'Namibia'},
  {id: 'geoTargetConstants/2520', value: 'Nauru'},
  {id: 'geoTargetConstants/2524', value: 'Nepal'},
  {id: 'geoTargetConstants/2528', value: 'Netherlands'},
  {id: 'geoTargetConstants/2531', value: 'Curacao'},
  {id: 'geoTargetConstants/2534', value: 'Sint Maarten'},
  {id: 'geoTargetConstants/2535', value: 'Caribbean Netherlands'},
  {id: 'geoTargetConstants/2540', value: 'New Caledonia'},
  {id: 'geoTargetConstants/2548', value: 'Vanuatu'},
  {id: 'geoTargetConstants/2554', value: 'New Zealand'},
  {id: 'geoTargetConstants/2558', value: 'Nicaragua'},
  {id: 'geoTargetConstants/2562', value: 'Niger'},
  {id: 'geoTargetConstants/2566', value: 'Nigeria'},
  {id: 'geoTargetConstants/2570', value: 'Niue'},
  {id: 'geoTargetConstants/2574', value: 'Norfolk Island'},
  {id: 'geoTargetConstants/2578', value: 'Norway'},
  {id: 'geoTargetConstants/2580', value: 'Northern Mariana Islands'},
  {
    id: 'geoTargetConstants/2581',
    value: 'United States Minor Outlying Islands',
  },
  {id: 'geoTargetConstants/2583', value: 'Micronesia'},
  {id: 'geoTargetConstants/2584', value: 'Marshall Islands'},
  {id: 'geoTargetConstants/2585', value: 'Palau'},
  {id: 'geoTargetConstants/2586', value: 'Pakistan'},
  {id: 'geoTargetConstants/2591', value: 'Panama'},
  {id: 'geoTargetConstants/2598', value: 'Papua New Guinea'},
  {id: 'geoTargetConstants/2600', value: 'Paraguay'},
  {id: 'geoTargetConstants/2604', value: 'Peru'},
  {id: 'geoTargetConstants/2608', value: 'Philippines'},
  {id: 'geoTargetConstants/2612', value: 'Pitcairn Islands'},
  {id: 'geoTargetConstants/2616', value: 'Poland'},
  {id: 'geoTargetConstants/2620', value: 'Portugal'},
  {id: 'geoTargetConstants/2624', value: 'Guinea-Bissau'},
  {id: 'geoTargetConstants/2626', value: 'Timor-Leste'},
  {id: 'geoTargetConstants/2634', value: 'Qatar'},
  {id: 'geoTargetConstants/2642', value: 'Romania'},
  {id: 'geoTargetConstants/2643', value: 'Russia'},
  {id: 'geoTargetConstants/2646', value: 'Rwanda'},
  {id: 'geoTargetConstants/2652', value: 'Saint Barthelemy'},
  {
    id: 'geoTargetConstants/2654',
    value: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {id: 'geoTargetConstants/2659', value: 'Saint Kitts and Nevis'},
  {id: 'geoTargetConstants/2662', value: 'Saint Lucia'},
  {id: 'geoTargetConstants/2663', value: 'Saint Martin'},
  {id: 'geoTargetConstants/2666', value: 'Saint Pierre and Miquelon'},
  {id: 'geoTargetConstants/2670', value: 'Saint Vincent and the Grenadines'},
  {id: 'geoTargetConstants/2674', value: 'San Marino'},
  {id: 'geoTargetConstants/2678', value: 'Sao Tome and Principe'},
  {id: 'geoTargetConstants/2682', value: 'Saudi Arabia'},
  {id: 'geoTargetConstants/2686', value: 'Senegal'},
  {id: 'geoTargetConstants/2688', value: 'Serbia'},
  {id: 'geoTargetConstants/2690', value: 'Seychelles'},
  {id: 'geoTargetConstants/2694', value: 'Sierra Leone'},
  {id: 'geoTargetConstants/2702', value: 'Singapore'},
  {id: 'geoTargetConstants/2703', value: 'Slovakia'},
  {id: 'geoTargetConstants/2704', value: 'Vietnam'},
  {id: 'geoTargetConstants/2705', value: 'Slovenia'},
  {id: 'geoTargetConstants/2706', value: 'Somalia'},
  {id: 'geoTargetConstants/2710', value: 'South Africa'},
  {id: 'geoTargetConstants/2716', value: 'Zimbabwe'},
  {id: 'geoTargetConstants/2724', value: 'Spain'},
  {id: 'geoTargetConstants/2728', value: 'South Sudan'},
  {id: 'geoTargetConstants/2736', value: 'Sudan'},
  {id: 'geoTargetConstants/2740', value: 'Suriname'},
  {id: 'geoTargetConstants/2748', value: 'Eswatini'},
  {id: 'geoTargetConstants/2752', value: 'Sweden'},
  {id: 'geoTargetConstants/2756', value: 'Switzerland'},
  {id: 'geoTargetConstants/2762', value: 'Tajikistan'},
  {id: 'geoTargetConstants/2764', value: 'Thailand'},
  {id: 'geoTargetConstants/2768', value: 'Togo'},
  {id: 'geoTargetConstants/2772', value: 'Tokelau'},
  {id: 'geoTargetConstants/2776', value: 'Tonga'},
  {id: 'geoTargetConstants/2780', value: 'Trinidad and Tobago'},
  {id: 'geoTargetConstants/2784', value: 'United Arab Emirates'},
  {id: 'geoTargetConstants/2788', value: 'Tunisia'},
  {id: 'geoTargetConstants/2792', value: 'Turkiye'},
  {id: 'geoTargetConstants/2795', value: 'Turkmenistan'},
  {id: 'geoTargetConstants/2798', value: 'Tuvalu'},
  {id: 'geoTargetConstants/2800', value: 'Uganda'},
  {id: 'geoTargetConstants/2804', value: 'Ukraine'},
  {id: 'geoTargetConstants/2807', value: 'North Macedonia'},
  {id: 'geoTargetConstants/2818', value: 'Egypt'},
  {id: 'geoTargetConstants/2826', value: 'United Kingdom'},
  {id: 'geoTargetConstants/2831', value: 'Guernsey'},
  {id: 'geoTargetConstants/2832', value: 'Jersey'},
  {id: 'geoTargetConstants/2833', value: 'Isle of Man'},
  {id: 'geoTargetConstants/2834', value: 'Tanzania'},
  {id: 'geoTargetConstants/2840', value: 'United States'},
  {id: 'geoTargetConstants/2854', value: 'Burkina Faso'},
  {id: 'geoTargetConstants/2858', value: 'Uruguay'},
  {id: 'geoTargetConstants/2860', value: 'Uzbekistan'},
  {id: 'geoTargetConstants/2862', value: 'Venezuela'},
  {id: 'geoTargetConstants/2876', value: 'Wallis and Futuna'},
  {id: 'geoTargetConstants/2882', value: 'Samoa'},
  {id: 'geoTargetConstants/2887', value: 'Yemen'},
  {id: 'geoTargetConstants/2894', value: 'Zambia'},
];

export const languageList = [
  {value: 'languageConstants/1000', lang: 'English'},
  {value: 'languageConstants/1001', lang: 'German'},
  {value: 'languageConstants/1002', lang: 'French'},
  {value: 'languageConstants/1003', lang: 'Spanish'},
  {value: 'languageConstants/1004', lang: 'Italian'},
  {value: 'languageConstants/1005', lang: 'Japanese'},
  //   {value: 'languageConstants/1006', lang: 'English (US)'},
  //   {value: 'languageConstants/1007', lang: 'English (UK)'},
  {value: 'languageConstants/1008', lang: 'Chinese'},
  {value: 'languageConstants/1009', lang: 'Danish'},
  {value: 'languageConstants/1010', lang: 'Dutch'},
  {value: 'languageConstants/1011', lang: 'Finnish'},
  {value: 'languageConstants/1012', lang: 'Korean'},
  {value: 'languageConstants/1013', lang: 'Norwegian'},
  {value: 'languageConstants/1014', lang: 'Portuguese'},
  {value: 'languageConstants/1015', lang: 'Swedish'},
  {value: 'languageConstants/1016', lang: 'Portuguese (Brazil)'},
  {value: 'languageConstants/1017', lang: 'Chinese (simplified)'},
  {value: 'languageConstants/1018', lang: 'Chinese (traditional)'},
  {value: 'languageConstants/1019', lang: 'Arabic'},
  {value: 'languageConstants/1020', lang: 'Bulgarian'},
  {value: 'languageConstants/1021', lang: 'Czech'},
  {value: 'languageConstants/1022', lang: 'Greek'},
  {value: 'languageConstants/1023', lang: 'Hindi'},
  {value: 'languageConstants/1024', lang: 'Hungarian'},
  {value: 'languageConstants/1025', lang: 'Indonesian'},
  {value: 'languageConstants/1026', lang: 'Icelandic'},
  {value: 'languageConstants/1027', lang: 'Hebrew'},
  {value: 'languageConstants/1028', lang: 'Latvian'},
  {value: 'languageConstants/1029', lang: 'Lithuanian'},
  {value: 'languageConstants/1030', lang: 'Polish'},
  {value: 'languageConstants/1031', lang: 'Russian'},
  {value: 'languageConstants/1032', lang: 'Romanian'},
  {value: 'languageConstants/1033', lang: 'Slovak'},
  {value: 'languageConstants/1034', lang: 'Slovenian'},
  {value: 'languageConstants/1035', lang: 'Serbian'},
  {value: 'languageConstants/1036', lang: 'Ukrainian'},
  {value: 'languageConstants/1037', lang: 'Turkish'},
  {value: 'languageConstants/1038', lang: 'Catalan'},
  {value: 'languageConstants/1039', lang: 'Croatian'},
  {value: 'languageConstants/1040', lang: 'Vietnamese'},
  {value: 'languageConstants/1041', lang: 'Urdu'},
  {value: 'languageConstants/1042', lang: 'Filipino'},
  {value: 'languageConstants/1043', lang: 'Estonian'},
  {value: 'languageConstants/1044', lang: 'Thai'},
  {value: 'languageConstants/1045', lang: 'Afar'},
  {value: 'languageConstants/1046', lang: 'Abkhazian'},
  {value: 'languageConstants/1047', lang: 'Afrikaans'},
  {value: 'languageConstants/1048', lang: 'Amharic'},
  {value: 'languageConstants/1049', lang: 'Assamese'},
  {value: 'languageConstants/1050', lang: 'Aymara'},
  {value: 'languageConstants/1051', lang: 'Azerbaijani'},
  {value: 'languageConstants/1052', lang: 'Bashkir'},
  {value: 'languageConstants/1053', lang: 'Belarusian'},
  {value: 'languageConstants/1054', lang: 'Bihari'},
  {value: 'languageConstants/1055', lang: 'Bislama'},
  {value: 'languageConstants/1056', lang: 'Bengali'},
  {value: 'languageConstants/1057', lang: 'Tibetan'},
  {value: 'languageConstants/1058', lang: 'Breton'},
  {value: 'languageConstants/1059', lang: 'Corsican'},
  {value: 'languageConstants/1060', lang: 'Welsh'},
  {value: 'languageConstants/1061', lang: 'Norwegian Nynorsk'},
  {value: 'languageConstants/1062', lang: 'Esperanto'},
  {value: 'languageConstants/1063', lang: 'Basque'},
  {value: 'languageConstants/1064', lang: 'Persian'},
  {value: 'languageConstants/1065', lang: 'Fijian'},
  {value: 'languageConstants/1066', lang: 'Faroese'},
  {value: 'languageConstants/1067', lang: 'Western Frisian'},
  {value: 'languageConstants/1068', lang: 'Irish'},
  {value: 'languageConstants/1069', lang: 'Scottish Gaelic'},
  {value: 'languageConstants/1070', lang: 'Galician'},
  {value: 'languageConstants/1071', lang: 'Guarani'},
  {value: 'languageConstants/1072', lang: 'Gujarati'},
  {value: 'languageConstants/1073', lang: 'Manx'},
  {value: 'languageConstants/1074', lang: 'Hausa'},
  {value: 'languageConstants/1075', lang: 'Bosnian'},
  {value: 'languageConstants/1076', lang: 'Armenian'},
  {value: 'languageConstants/1077', lang: 'Interlingua'},
  {value: 'languageConstants/1078', lang: 'Interlingue'},
  {value: 'languageConstants/1079', lang: 'Inupiaq'},
  {value: 'languageConstants/1080', lang: 'Inuktitut'},
  {value: 'languageConstants/1081', lang: 'Javanese'},
  {value: 'languageConstants/1082', lang: 'Georgian'},
  {value: 'languageConstants/1083', lang: 'Kazakh'},
  {value: 'languageConstants/1084', lang: 'Greenlandic'},
  {value: 'languageConstants/1085', lang: 'Khmer'},
  {value: 'languageConstants/1086', lang: 'Kannada'},
  {value: 'languageConstants/1087', lang: 'Kashmiri'},
  {value: 'languageConstants/1088', lang: 'Kurdish'},
  {value: 'languageConstants/1089', lang: 'Cornish'},
  {value: 'languageConstants/1090', lang: 'Kirghiz'},
  {value: 'languageConstants/1091', lang: 'Latin'},
  {value: 'languageConstants/1092', lang: 'Luxembourgish'},
  {value: 'languageConstants/1093', lang: 'Lingala'},
  {value: 'languageConstants/1094', lang: 'Lao'},
  {value: 'languageConstants/1095', lang: 'Malagasy'},
  {value: 'languageConstants/1096', lang: 'Maori'},
  {value: 'languageConstants/1097', lang: 'Macedonian'},
  {value: 'languageConstants/1098', lang: 'Malayalam'},
  {value: 'languageConstants/1099', lang: 'Mongolian'},
  {value: 'languageConstants/1100', lang: 'Moldavian'},
  {value: 'languageConstants/1101', lang: 'Marathi'},
  {value: 'languageConstants/1102', lang: 'Malay'},
  {value: 'languageConstants/1103', lang: 'Maltese'},
  {value: 'languageConstants/1104', lang: 'Burmese'},
  {value: 'languageConstants/1105', lang: 'Nauru'},
  {value: 'languageConstants/1106', lang: 'Nepali'},
  {value: 'languageConstants/1107', lang: 'Occitan'},
  {value: 'languageConstants/1108', lang: '(Afan) Oromo'},
  {value: 'languageConstants/1109', lang: 'Oriya'},
  {value: 'languageConstants/1110', lang: 'Punjabi'},
  {value: 'languageConstants/1111', lang: 'Pushto'},
  {value: 'languageConstants/1112', lang: 'Quechua'},
  {value: 'languageConstants/1113', lang: 'Raeto-Romance'},
  {value: 'languageConstants/1114', lang: 'Rundi'},
  {value: 'languageConstants/1115', lang: 'Kinyarwanda'},
  {value: 'languageConstants/1116', lang: 'Sanskrit'},
  {value: 'languageConstants/1117', lang: 'Sindhi'},
  {value: 'languageConstants/1118', lang: 'Northern Sámi'},
  {value: 'languageConstants/1119', lang: 'Sango'},
  {value: 'languageConstants/1120', lang: 'Zulu'},
  {value: 'languageConstants/1121', lang: 'Sinhalese'},
  {value: 'languageConstants/1122', lang: 'Samoan'},
  {value: 'languageConstants/1123', lang: 'Shona'},
  {value: 'languageConstants/1124', lang: 'Somali'},
  {value: 'languageConstants/1125', lang: 'Albanian'},
  {value: 'languageConstants/1126', lang: 'Swati'},
  {value: 'languageConstants/1127', lang: 'Sotho'},
  {value: 'languageConstants/1128', lang: 'Sundanese'},
  {value: 'languageConstants/1129', lang: 'Swahili'},
  {value: 'languageConstants/1130', lang: 'Tamil'},
  {value: 'languageConstants/1131', lang: 'Telugu'},
  {value: 'languageConstants/1132', lang: 'Tajik'},
  {value: 'languageConstants/1133', lang: 'Tigrinya'},
  {value: 'languageConstants/1134', lang: 'Turkmen'},
  {value: 'languageConstants/1135', lang: 'Tswana'},
  {value: 'languageConstants/1136', lang: 'Tonga'},
  {value: 'languageConstants/1137', lang: 'Tsonga'},
  {value: 'languageConstants/1138', lang: 'Tatar'},
  {value: 'languageConstants/1139', lang: 'Twi'},
  {value: 'languageConstants/1140', lang: 'Uighur'},
  {value: 'languageConstants/1141', lang: 'Uzbek'},
  {value: 'languageConstants/1142', lang: 'Volapük'},
  {value: 'languageConstants/1143', lang: 'Wolof'},
  {value: 'languageConstants/1144', lang: 'Xhosa'},
  {value: 'languageConstants/1145', lang: 'Yiddish'},
  {value: 'languageConstants/1146', lang: 'Yoruba'},
  {value: 'languageConstants/1147', lang: 'Zhuang'},
  //   {value: 'languageConstants/1148', lang: 'English (Australia)'},
  {value: 'languageConstants/1149', lang: 'Portuguese (Portugal)'},
  {value: 'languageConstants/1150', lang: 'Chinese (Hong Kong SAR)'},
];

const getFormattedListJSON = `
[
    {
        "id": 1,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Afghanistan",
        "country_code": "AF",
        "resource": "geoTargetConstants/2004"
    },
    {
        "id": 2,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Albania",
        "country_code": "AL",
        "resource": "geoTargetConstants/2008"
    },
    {
        "id": 3,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Antarctica",
        "country_code": "AQ",
        "resource": "geoTargetConstants/2010"
    },
    {
        "id": 4,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Algeria",
        "country_code": "DZ",
        "resource": "geoTargetConstants/2012"
    },
    {
        "id": 5,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "American Samoa",
        "country_code": "AS",
        "resource": "geoTargetConstants/2016"
    },
    {
        "id": 6,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Andorra",
        "country_code": "AD",
        "resource": "geoTargetConstants/2020"
    },
    {
        "id": 7,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Angola",
        "country_code": "AO",
        "resource": "geoTargetConstants/2024"
    },
    {
        "id": 8,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Antigua and Barbuda",
        "country_code": "AG",
        "resource": "geoTargetConstants/2028"
    },
    {
        "id": 9,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Azerbaijan",
        "country_code": "AZ",
        "resource": "geoTargetConstants/2031"
    },
    {
        "id": 10,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Argentina",
        "country_code": "AR",
        "resource": "geoTargetConstants/2032"
    },
    {
        "id": 11,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Australia",
        "country_code": "AU",
        "resource": "geoTargetConstants/2036"
    },
    {
        "id": 12,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Austria",
        "country_code": "AT",
        "resource": "geoTargetConstants/2040"
    },
    {
        "id": 13,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "The Bahamas",
        "country_code": "BS",
        "resource": "geoTargetConstants/2044"
    },
    {
        "id": 14,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Bahrain",
        "country_code": "BH",
        "resource": "geoTargetConstants/2048"
    },
    {
        "id": 15,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Bangladesh",
        "country_code": "BD",
        "resource": "geoTargetConstants/2050"
    },
    {
        "id": 16,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Armenia",
        "country_code": "AM",
        "resource": "geoTargetConstants/2051"
    },
    {
        "id": 17,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Barbados",
        "country_code": "BB",
        "resource": "geoTargetConstants/2052"
    },
    {
        "id": 18,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Belgium",
        "country_code": "BE",
        "resource": "geoTargetConstants/2056"
    },
    {
        "id": 19,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Bhutan",
        "country_code": "BT",
        "resource": "geoTargetConstants/2064"
    },
    {
        "id": 20,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Bolivia",
        "country_code": "BO",
        "resource": "geoTargetConstants/2068"
    },
    {
        "id": 21,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Bosnia and Herzegovina",
        "country_code": "BA",
        "resource": "geoTargetConstants/2070"
    },
    {
        "id": 22,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Botswana",
        "country_code": "BW",
        "resource": "geoTargetConstants/2072"
    },
    {
        "id": 23,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Brazil",
        "country_code": "BR",
        "resource": "geoTargetConstants/2076"
    },
    {
        "id": 24,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Belize",
        "country_code": "BZ",
        "resource": "geoTargetConstants/2084"
    },
    {
        "id": 25,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Solomon Islands",
        "country_code": "SB",
        "resource": "geoTargetConstants/2090"
    },
    {
        "id": 26,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Brunei",
        "country_code": "BN",
        "resource": "geoTargetConstants/2096"
    },
    {
        "id": 27,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Bulgaria",
        "country_code": "BG",
        "resource": "geoTargetConstants/2100"
    },
    {
        "id": 28,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Myanmar (Burma)",
        "country_code": "MM",
        "resource": "geoTargetConstants/2104"
    },
    {
        "id": 29,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Burundi",
        "country_code": "BI",
        "resource": "geoTargetConstants/2108"
    },
    {
        "id": 30,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Belarus",
        "country_code": "BY",
        "resource": "geoTargetConstants/2112"
    },
    {
        "id": 31,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Cambodia",
        "country_code": "KH",
        "resource": "geoTargetConstants/2116"
    },
    {
        "id": 32,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Cameroon",
        "country_code": "CM",
        "resource": "geoTargetConstants/2120"
    },
    {
        "id": 33,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Canada",
        "country_code": "CA",
        "resource": "geoTargetConstants/2124"
    },
    {
        "id": 34,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Cabo Verde",
        "country_code": "CV",
        "resource": "geoTargetConstants/2132"
    },
    {
        "id": 35,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Central African Republic",
        "country_code": "CF",
        "resource": "geoTargetConstants/2140"
    },
    {
        "id": 36,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Sri Lanka",
        "country_code": "LK",
        "resource": "geoTargetConstants/2144"
    },
    {
        "id": 37,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Chad",
        "country_code": "TD",
        "resource": "geoTargetConstants/2148"
    },
    {
        "id": 38,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Chile",
        "country_code": "CL",
        "resource": "geoTargetConstants/2152"
    },
    {
        "id": 39,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "China",
        "country_code": "CN",
        "resource": "geoTargetConstants/2156"
    },
    {
        "id": 40,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Christmas Island",
        "country_code": "CX",
        "resource": "geoTargetConstants/2162"
    },
    {
        "id": 41,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Cocos (Keeling) Islands",
        "country_code": "CC",
        "resource": "geoTargetConstants/2166"
    },
    {
        "id": 42,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Colombia",
        "country_code": "CO",
        "resource": "geoTargetConstants/2170"
    },
    {
        "id": 43,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Comoros",
        "country_code": "KM",
        "resource": "geoTargetConstants/2174"
    },
    {
        "id": 44,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Republic of the Congo",
        "country_code": "CG",
        "resource": "geoTargetConstants/2178"
    },
    {
        "id": 45,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Democratic Republic of the Congo",
        "country_code": "CD",
        "resource": "geoTargetConstants/2180"
    },
    {
        "id": 46,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Cook Islands",
        "country_code": "CK",
        "resource": "geoTargetConstants/2184"
    },
    {
        "id": 47,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Costa Rica",
        "country_code": "CR",
        "resource": "geoTargetConstants/2188"
    },
    {
        "id": 48,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Croatia",
        "country_code": "HR",
        "resource": "geoTargetConstants/2191"
    },
    {
        "id": 49,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Cyprus",
        "country_code": "CY",
        "resource": "geoTargetConstants/2196"
    },
    {
        "id": 50,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Czechia",
        "country_code": "CZ",
        "resource": "geoTargetConstants/2203"
    },
    {
        "id": 51,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Benin",
        "country_code": "BJ",
        "resource": "geoTargetConstants/2204"
    },
    {
        "id": 52,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Denmark",
        "country_code": "DK",
        "resource": "geoTargetConstants/2208"
    },
    {
        "id": 53,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Dominica",
        "country_code": "DM",
        "resource": "geoTargetConstants/2212"
    },
    {
        "id": 54,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Dominican Republic",
        "country_code": "DO",
        "resource": "geoTargetConstants/2214"
    },
    {
        "id": 55,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Ecuador",
        "country_code": "EC",
        "resource": "geoTargetConstants/2218"
    },
    {
        "id": 56,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "El Salvador",
        "country_code": "SV",
        "resource": "geoTargetConstants/2222"
    },
    {
        "id": 57,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Equatorial Guinea",
        "country_code": "GQ",
        "resource": "geoTargetConstants/2226"
    },
    {
        "id": 58,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Ethiopia",
        "country_code": "ET",
        "resource": "geoTargetConstants/2231"
    },
    {
        "id": 59,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Eritrea",
        "country_code": "ER",
        "resource": "geoTargetConstants/2232"
    },
    {
        "id": 60,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Estonia",
        "country_code": "EE",
        "resource": "geoTargetConstants/2233"
    },
    {
        "id": 61,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "South Georgia and the South Sandwich Islands",
        "country_code": "GS",
        "resource": "geoTargetConstants/2239"
    },
    {
        "id": 62,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Fiji",
        "country_code": "FJ",
        "resource": "geoTargetConstants/2242"
    },
    {
        "id": 63,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Finland",
        "country_code": "FI",
        "resource": "geoTargetConstants/2246"
    },
    {
        "id": 64,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "France",
        "country_code": "FR",
        "resource": "geoTargetConstants/2250"
    },
    {
        "id": 65,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "French Polynesia",
        "country_code": "PF",
        "resource": "geoTargetConstants/2258"
    },
    {
        "id": 66,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "French Southern and Antarctic Lands",
        "country_code": "TF",
        "resource": "geoTargetConstants/2260"
    },
    {
        "id": 67,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Djibouti",
        "country_code": "DJ",
        "resource": "geoTargetConstants/2262"
    },
    {
        "id": 68,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Gabon",
        "country_code": "GA",
        "resource": "geoTargetConstants/2266"
    },
    {
        "id": 69,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Georgia",
        "country_code": "GE",
        "resource": "geoTargetConstants/2268"
    },
    {
        "id": 70,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "The Gambia",
        "country_code": "GM",
        "resource": "geoTargetConstants/2270"
    },
    {
        "id": 71,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Germany",
        "country_code": "DE",
        "resource": "geoTargetConstants/2276"
    },
    {
        "id": 72,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Ghana",
        "country_code": "GH",
        "resource": "geoTargetConstants/2288"
    },
    {
        "id": 73,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Kiribati",
        "country_code": "KI",
        "resource": "geoTargetConstants/2296"
    },
    {
        "id": 74,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Greece",
        "country_code": "GR",
        "resource": "geoTargetConstants/2300"
    },
    {
        "id": 75,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Grenada",
        "country_code": "GD",
        "resource": "geoTargetConstants/2308"
    },
    {
        "id": 76,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Guam",
        "country_code": "GU",
        "resource": "geoTargetConstants/2316"
    },
    {
        "id": 77,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Guatemala",
        "country_code": "GT",
        "resource": "geoTargetConstants/2320"
    },
    {
        "id": 78,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Guinea",
        "country_code": "GN",
        "resource": "geoTargetConstants/2324"
    },
    {
        "id": 79,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Guyana",
        "country_code": "GY",
        "resource": "geoTargetConstants/2328"
    },
    {
        "id": 80,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Haiti",
        "country_code": "HT",
        "resource": "geoTargetConstants/2332"
    },
    {
        "id": 81,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Heard Island and McDonald Islands",
        "country_code": "HM",
        "resource": "geoTargetConstants/2334"
    },
    {
        "id": 82,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Vatican City",
        "country_code": "VA",
        "resource": "geoTargetConstants/2336"
    },
    {
        "id": 83,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Honduras",
        "country_code": "HN",
        "resource": "geoTargetConstants/2340"
    },
    {
        "id": 84,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Hungary",
        "country_code": "HU",
        "resource": "geoTargetConstants/2348"
    },
    {
        "id": 85,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Iceland",
        "country_code": "IS",
        "resource": "geoTargetConstants/2352"
    },
    {
        "id": 86,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "India",
        "country_code": "IN",
        "resource": "geoTargetConstants/2356"
    },
    {
        "id": 87,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Indonesia",
        "country_code": "ID",
        "resource": "geoTargetConstants/2360"
    },
    {
        "id": 88,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Iraq",
        "country_code": "IQ",
        "resource": "geoTargetConstants/2368"
    },
    {
        "id": 89,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Ireland",
        "country_code": "IE",
        "resource": "geoTargetConstants/2372"
    },
    {
        "id": 90,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Israel",
        "country_code": "IL",
        "resource": "geoTargetConstants/2376"
    },
    {
        "id": 91,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Italy",
        "country_code": "IT",
        "resource": "geoTargetConstants/2380"
    },
    {
        "id": 92,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Cote d'Ivoire",
        "country_code": "CI",
        "resource": "geoTargetConstants/2384"
    },
    {
        "id": 93,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Jamaica",
        "country_code": "JM",
        "resource": "geoTargetConstants/2388"
    },
    {
        "id": 94,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Japan",
        "country_code": "JP",
        "resource": "geoTargetConstants/2392"
    },
    {
        "id": 95,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Kazakhstan",
        "country_code": "KZ",
        "resource": "geoTargetConstants/2398"
    },
    {
        "id": 96,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Jordan",
        "country_code": "JO",
        "resource": "geoTargetConstants/2400"
    },
    {
        "id": 97,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Kenya",
        "country_code": "KE",
        "resource": "geoTargetConstants/2404"
    },
    {
        "id": 98,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "South Korea",
        "country_code": "KR",
        "resource": "geoTargetConstants/2410"
    },
    {
        "id": 99,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Kuwait",
        "country_code": "KW",
        "resource": "geoTargetConstants/2414"
    },
    {
        "id": 100,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Kyrgyzstan",
        "country_code": "KG",
        "resource": "geoTargetConstants/2417"
    },
    {
        "id": 101,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Laos",
        "country_code": "LA",
        "resource": "geoTargetConstants/2418"
    },
    {
        "id": 102,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Lebanon",
        "country_code": "LB",
        "resource": "geoTargetConstants/2422"
    },
    {
        "id": 103,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Lesotho",
        "country_code": "LS",
        "resource": "geoTargetConstants/2426"
    },
    {
        "id": 104,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Latvia",
        "country_code": "LV",
        "resource": "geoTargetConstants/2428"
    },
    {
        "id": 105,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Liberia",
        "country_code": "LR",
        "resource": "geoTargetConstants/2430"
    },
    {
        "id": 106,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Libya",
        "country_code": "LY",
        "resource": "geoTargetConstants/2434"
    },
    {
        "id": 107,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Liechtenstein",
        "country_code": "LI",
        "resource": "geoTargetConstants/2438"
    },
    {
        "id": 108,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Lithuania",
        "country_code": "LT",
        "resource": "geoTargetConstants/2440"
    },
    {
        "id": 109,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Luxembourg",
        "country_code": "LU",
        "resource": "geoTargetConstants/2442"
    },
    {
        "id": 110,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Madagascar",
        "country_code": "MG",
        "resource": "geoTargetConstants/2450"
    },
    {
        "id": 111,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Malawi",
        "country_code": "MW",
        "resource": "geoTargetConstants/2454"
    },
    {
        "id": 112,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Malaysia",
        "country_code": "MY",
        "resource": "geoTargetConstants/2458"
    },
    {
        "id": 113,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Maldives",
        "country_code": "MV",
        "resource": "geoTargetConstants/2462"
    },
    {
        "id": 114,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Mali",
        "country_code": "ML",
        "resource": "geoTargetConstants/2466"
    },
    {
        "id": 115,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Malta",
        "country_code": "MT",
        "resource": "geoTargetConstants/2470"
    },
    {
        "id": 116,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Mauritania",
        "country_code": "MR",
        "resource": "geoTargetConstants/2478"
    },
    {
        "id": 117,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Mauritius",
        "country_code": "MU",
        "resource": "geoTargetConstants/2480"
    },
    {
        "id": 118,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Mexico",
        "country_code": "MX",
        "resource": "geoTargetConstants/2484"
    },
    {
        "id": 119,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Monaco",
        "country_code": "MC",
        "resource": "geoTargetConstants/2492"
    },
    {
        "id": 120,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Mongolia",
        "country_code": "MN",
        "resource": "geoTargetConstants/2496"
    },
    {
        "id": 121,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Moldova",
        "country_code": "MD",
        "resource": "geoTargetConstants/2498"
    },
    {
        "id": 122,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Montenegro",
        "country_code": "ME",
        "resource": "geoTargetConstants/2499"
    },
    {
        "id": 123,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Morocco",
        "country_code": "MA",
        "resource": "geoTargetConstants/2504"
    },
    {
        "id": 124,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Mozambique",
        "country_code": "MZ",
        "resource": "geoTargetConstants/2508"
    },
    {
        "id": 125,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Oman",
        "country_code": "OM",
        "resource": "geoTargetConstants/2512"
    },
    {
        "id": 126,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Namibia",
        "country_code": "NA",
        "resource": "geoTargetConstants/2516"
    },
    {
        "id": 127,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Nauru",
        "country_code": "NR",
        "resource": "geoTargetConstants/2520"
    },
    {
        "id": 128,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Nepal",
        "country_code": "NP",
        "resource": "geoTargetConstants/2524"
    },
    {
        "id": 129,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Netherlands",
        "country_code": "NL",
        "resource": "geoTargetConstants/2528"
    },
    {
        "id": 130,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Curacao",
        "country_code": "CW",
        "resource": "geoTargetConstants/2531"
    },
    {
        "id": 131,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Sint Maarten",
        "country_code": "SX",
        "resource": "geoTargetConstants/2534"
    },
    {
        "id": 132,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Caribbean Netherlands",
        "country_code": "BQ",
        "resource": "geoTargetConstants/2535"
    },
    {
        "id": 133,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "New Caledonia",
        "country_code": "NC",
        "resource": "geoTargetConstants/2540"
    },
    {
        "id": 134,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Vanuatu",
        "country_code": "VU",
        "resource": "geoTargetConstants/2548"
    },
    {
        "id": 135,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "New Zealand",
        "country_code": "NZ",
        "resource": "geoTargetConstants/2554"
    },
    {
        "id": 136,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Nicaragua",
        "country_code": "NI",
        "resource": "geoTargetConstants/2558"
    },
    {
        "id": 137,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Niger",
        "country_code": "NE",
        "resource": "geoTargetConstants/2562"
    },
    {
        "id": 138,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Nigeria",
        "country_code": "NG",
        "resource": "geoTargetConstants/2566"
    },
    {
        "id": 139,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Niue",
        "country_code": "NU",
        "resource": "geoTargetConstants/2570"
    },
    {
        "id": 140,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Norfolk Island",
        "country_code": "NF",
        "resource": "geoTargetConstants/2574"
    },
    {
        "id": 141,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Norway",
        "country_code": "NO",
        "resource": "geoTargetConstants/2578"
    },
    {
        "id": 142,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Northern Mariana Islands",
        "country_code": "MP",
        "resource": "geoTargetConstants/2580"
    },
    {
        "id": 143,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "United States Minor Outlying Islands",
        "country_code": "UM",
        "resource": "geoTargetConstants/2581"
    },
    {
        "id": 144,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Micronesia",
        "country_code": "FM",
        "resource": "geoTargetConstants/2583"
    },
    {
        "id": 145,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Marshall Islands",
        "country_code": "MH",
        "resource": "geoTargetConstants/2584"
    },
    {
        "id": 146,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Palau",
        "country_code": "PW",
        "resource": "geoTargetConstants/2585"
    },
    {
        "id": 147,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Pakistan",
        "country_code": "PK",
        "resource": "geoTargetConstants/2586"
    },
    {
        "id": 148,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Panama",
        "country_code": "PA",
        "resource": "geoTargetConstants/2591"
    },
    {
        "id": 149,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Papua New Guinea",
        "country_code": "PG",
        "resource": "geoTargetConstants/2598"
    },
    {
        "id": 150,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Paraguay",
        "country_code": "PY",
        "resource": "geoTargetConstants/2600"
    },
    {
        "id": 151,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Peru",
        "country_code": "PE",
        "resource": "geoTargetConstants/2604"
    },
    {
        "id": 152,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Philippines",
        "country_code": "PH",
        "resource": "geoTargetConstants/2608"
    },
    {
        "id": 153,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Pitcairn Islands",
        "country_code": "PN",
        "resource": "geoTargetConstants/2612"
    },
    {
        "id": 154,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Poland",
        "country_code": "PL",
        "resource": "geoTargetConstants/2616"
    },
    {
        "id": 155,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Portugal",
        "country_code": "PT",
        "resource": "geoTargetConstants/2620"
    },
    {
        "id": 156,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Guinea-Bissau",
        "country_code": "GW",
        "resource": "geoTargetConstants/2624"
    },
    {
        "id": 157,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Timor-Leste",
        "country_code": "TL",
        "resource": "geoTargetConstants/2626"
    },
    {
        "id": 158,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Qatar",
        "country_code": "QA",
        "resource": "geoTargetConstants/2634"
    },
    {
        "id": 159,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Romania",
        "country_code": "RO",
        "resource": "geoTargetConstants/2642"
    },
    {
        "id": 160,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Russia",
        "country_code": "RU",
        "resource": "geoTargetConstants/2643"
    },
    {
        "id": 161,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Rwanda",
        "country_code": "RW",
        "resource": "geoTargetConstants/2646"
    },
    {
        "id": 162,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saint Barthelemy",
        "country_code": "BL",
        "resource": "geoTargetConstants/2652"
    },
    {
        "id": 163,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "country_code": "SH",
        "resource": "geoTargetConstants/2654"
    },
    {
        "id": 164,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saint Kitts and Nevis",
        "country_code": "KN",
        "resource": "geoTargetConstants/2659"
    },
    {
        "id": 165,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saint Lucia",
        "country_code": "LC",
        "resource": "geoTargetConstants/2662"
    },
    {
        "id": 166,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saint Martin",
        "country_code": "MF",
        "resource": "geoTargetConstants/2663"
    },
    {
        "id": 167,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saint Pierre and Miquelon",
        "country_code": "PM",
        "resource": "geoTargetConstants/2666"
    },
    {
        "id": 168,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saint Vincent and the Grenadines",
        "country_code": "VC",
        "resource": "geoTargetConstants/2670"
    },
    {
        "id": 169,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "San Marino",
        "country_code": "SM",
        "resource": "geoTargetConstants/2674"
    },
    {
        "id": 170,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Sao Tome and Principe",
        "country_code": "ST",
        "resource": "geoTargetConstants/2678"
    },
    {
        "id": 171,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Saudi Arabia",
        "country_code": "SA",
        "resource": "geoTargetConstants/2682"
    },
    {
        "id": 172,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Senegal",
        "country_code": "SN",
        "resource": "geoTargetConstants/2686"
    },
    {
        "id": 173,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Serbia",
        "country_code": "RS",
        "resource": "geoTargetConstants/2688"
    },
    {
        "id": 174,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Seychelles",
        "country_code": "SC",
        "resource": "geoTargetConstants/2690"
    },
    {
        "id": 175,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Sierra Leone",
        "country_code": "SL",
        "resource": "geoTargetConstants/2694"
    },
    {
        "id": 176,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Singapore",
        "country_code": "SG",
        "resource": "geoTargetConstants/2702"
    },
    {
        "id": 177,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Slovakia",
        "country_code": "SK",
        "resource": "geoTargetConstants/2703"
    },
    {
        "id": 178,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Vietnam",
        "country_code": "VN",
        "resource": "geoTargetConstants/2704"
    },
    {
        "id": 179,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Slovenia",
        "country_code": "SI",
        "resource": "geoTargetConstants/2705"
    },
    {
        "id": 180,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Somalia",
        "country_code": "SO",
        "resource": "geoTargetConstants/2706"
    },
    {
        "id": 181,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "South Africa",
        "country_code": "ZA",
        "resource": "geoTargetConstants/2710"
    },
    {
        "id": 182,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Zimbabwe",
        "country_code": "ZW",
        "resource": "geoTargetConstants/2716"
    },
    {
        "id": 183,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Spain",
        "country_code": "ES",
        "resource": "geoTargetConstants/2724"
    },
    {
        "id": 184,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "South Sudan",
        "country_code": "SS",
        "resource": "geoTargetConstants/2728"
    },
    {
        "id": 185,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Sudan",
        "country_code": "SD",
        "resource": "geoTargetConstants/2736"
    },
    {
        "id": 186,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Suriname",
        "country_code": "SR",
        "resource": "geoTargetConstants/2740"
    },
    {
        "id": 187,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Eswatini",
        "country_code": "SZ",
        "resource": "geoTargetConstants/2748"
    },
    {
        "id": 188,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Sweden",
        "country_code": "SE",
        "resource": "geoTargetConstants/2752"
    },
    {
        "id": 189,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Switzerland",
        "country_code": "CH",
        "resource": "geoTargetConstants/2756"
    },
    {
        "id": 190,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Tajikistan",
        "country_code": "TJ",
        "resource": "geoTargetConstants/2762"
    },
    {
        "id": 191,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Thailand",
        "country_code": "TH",
        "resource": "geoTargetConstants/2764"
    },
    {
        "id": 192,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Togo",
        "country_code": "TG",
        "resource": "geoTargetConstants/2768"
    },
    {
        "id": 193,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Tokelau",
        "country_code": "TK",
        "resource": "geoTargetConstants/2772"
    },
    {
        "id": 194,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Tonga",
        "country_code": "TO",
        "resource": "geoTargetConstants/2776"
    },
    {
        "id": 195,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Trinidad and Tobago",
        "country_code": "TT",
        "resource": "geoTargetConstants/2780"
    },
    {
        "id": 196,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "United Arab Emirates",
        "country_code": "AE",
        "resource": "geoTargetConstants/2784"
    },
    {
        "id": 197,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Tunisia",
        "country_code": "TN",
        "resource": "geoTargetConstants/2788"
    },
    {
        "id": 198,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Turkiye",
        "country_code": "TR",
        "resource": "geoTargetConstants/2792"
    },
    {
        "id": 199,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Turkmenistan",
        "country_code": "TM",
        "resource": "geoTargetConstants/2795"
    },
    {
        "id": 200,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Tuvalu",
        "country_code": "TV",
        "resource": "geoTargetConstants/2798"
    },
    {
        "id": 201,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Uganda",
        "country_code": "UG",
        "resource": "geoTargetConstants/2800"
    },
    {
        "id": 202,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Ukraine",
        "country_code": "UA",
        "resource": "geoTargetConstants/2804"
    },
    {
        "id": 203,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "North Macedonia",
        "country_code": "MK",
        "resource": "geoTargetConstants/2807"
    },
    {
        "id": 204,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Egypt",
        "country_code": "EG",
        "resource": "geoTargetConstants/2818"
    },
    {
        "id": 205,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "United Kingdom",
        "country_code": "GB",
        "resource": "geoTargetConstants/2826"
    },
    {
        "id": 206,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Guernsey",
        "country_code": "GG",
        "resource": "geoTargetConstants/2831"
    },
    {
        "id": 207,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Jersey",
        "country_code": "JE",
        "resource": "geoTargetConstants/2832"
    },
    {
        "id": 208,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Isle of Man",
        "country_code": "IM",
        "resource": "geoTargetConstants/2833"
    },
    {
        "id": 209,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Tanzania",
        "country_code": "TZ",
        "resource": "geoTargetConstants/2834"
    },
    {
        "id": 210,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "United States",
        "country_code": "US",
        "resource": "geoTargetConstants/2840"
    },
    {
        "id": 211,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Burkina Faso",
        "country_code": "BF",
        "resource": "geoTargetConstants/2854"
    },
    {
        "id": 212,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Uruguay",
        "country_code": "UY",
        "resource": "geoTargetConstants/2858"
    },
    {
        "id": 213,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Uzbekistan",
        "country_code": "UZ",
        "resource": "geoTargetConstants/2860"
    },
    {
        "id": 214,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Venezuela",
        "country_code": "VE",
        "resource": "geoTargetConstants/2862"
    },
    {
        "id": 215,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Wallis and Futuna",
        "country_code": "WF",
        "resource": "geoTargetConstants/2876"
    },
    {
        "id": 216,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Samoa",
        "country_code": "WS",
        "resource": "geoTargetConstants/2882"
    },
    {
        "id": 217,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Yemen",
        "country_code": "YE",
        "resource": "geoTargetConstants/2887"
    },
    {
        "id": 218,
        "created_at": "2025-05-19T09:29:30.000000Z",
        "updated_at": "2025-05-19T09:29:30.000000Z",
        "name": "Zambia",
        "country_code": "ZM",
        "resource": "geoTargetConstants/2894"
    }
]
`;

export const getFormattedList = JSON.parse(getFormattedListJSON);

const langListJSON = [
  {
    id: 1,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'English',
    resource: 'languageConstants/1000',
  },
  {
    id: 2,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'German',
    resource: 'languageConstants/1001',
  },
  {
    id: 3,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'French',
    resource: 'languageConstants/1002',
  },
  {
    id: 4,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Spanish',
    resource: 'languageConstants/1003',
  },
  {
    id: 5,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Italian',
    resource: 'languageConstants/1004',
  },
  {
    id: 6,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Japanese',
    resource: 'languageConstants/1005',
  },
  //   {
  //     id: 7,
  //     created_at: '2025-05-19T09:29:31.000000Z',
  //     updated_at: '2025-05-19T09:29:31.000000Z',
  //     name: 'English (US)',
  //     resource: 'languageConstants/1006',
  //   },
  //   {
  //     id: 8,
  //     created_at: '2025-05-19T09:29:31.000000Z',
  //     updated_at: '2025-05-19T09:29:31.000000Z',
  //     name: 'English (UK)',
  //     resource: 'languageConstants/1007',
  //   },
  {
    id: 9,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Chinese',
    resource: 'languageConstants/1008',
  },
  {
    id: 10,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Danish',
    resource: 'languageConstants/1009',
  },
  {
    id: 11,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Dutch',
    resource: 'languageConstants/1010',
  },
  {
    id: 12,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Finnish',
    resource: 'languageConstants/1011',
  },
  {
    id: 13,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Korean',
    resource: 'languageConstants/1012',
  },
  {
    id: 14,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Norwegian',
    resource: 'languageConstants/1013',
  },
  {
    id: 15,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Portuguese',
    resource: 'languageConstants/1014',
  },
  {
    id: 16,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Swedish',
    resource: 'languageConstants/1015',
  },
  {
    id: 17,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Portuguese (Brazil)',
    resource: 'languageConstants/1016',
  },
  {
    id: 18,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Chinese (simplified)',
    resource: 'languageConstants/1017',
  },
  {
    id: 19,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Chinese (traditional)',
    resource: 'languageConstants/1018',
  },
  {
    id: 20,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Arabic',
    resource: 'languageConstants/1019',
  },
  {
    id: 21,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Bulgarian',
    resource: 'languageConstants/1020',
  },
  {
    id: 22,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Czech',
    resource: 'languageConstants/1021',
  },
  {
    id: 23,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Greek',
    resource: 'languageConstants/1022',
  },
  {
    id: 24,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Hindi',
    resource: 'languageConstants/1023',
  },
  {
    id: 25,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Hungarian',
    resource: 'languageConstants/1024',
  },
  {
    id: 26,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Indonesian',
    resource: 'languageConstants/1025',
  },
  {
    id: 27,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Icelandic',
    resource: 'languageConstants/1026',
  },
  {
    id: 28,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Hebrew',
    resource: 'languageConstants/1027',
  },
  {
    id: 29,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Latvian',
    resource: 'languageConstants/1028',
  },
  {
    id: 30,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Lithuanian',
    resource: 'languageConstants/1029',
  },
  {
    id: 31,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Polish',
    resource: 'languageConstants/1030',
  },
  {
    id: 32,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Russian',
    resource: 'languageConstants/1031',
  },
  {
    id: 33,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Romanian',
    resource: 'languageConstants/1032',
  },
  {
    id: 34,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Slovak',
    resource: 'languageConstants/1033',
  },
  {
    id: 35,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Slovenian',
    resource: 'languageConstants/1034',
  },
  {
    id: 36,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Serbian',
    resource: 'languageConstants/1035',
  },
  {
    id: 37,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Ukrainian',
    resource: 'languageConstants/1036',
  },
  {
    id: 38,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Turkish',
    resource: 'languageConstants/1037',
  },
  {
    id: 39,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Catalan',
    resource: 'languageConstants/1038',
  },
  {
    id: 40,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Croatian',
    resource: 'languageConstants/1039',
  },
  {
    id: 41,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Vietnamese',
    resource: 'languageConstants/1040',
  },
  {
    id: 42,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Urdu',
    resource: 'languageConstants/1041',
  },
  {
    id: 43,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Filipino',
    resource: 'languageConstants/1042',
  },
  {
    id: 44,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Estonian',
    resource: 'languageConstants/1043',
  },
  {
    id: 45,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Thai',
    resource: 'languageConstants/1044',
  },
  {
    id: 46,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Afar',
    resource: 'languageConstants/1045',
  },
  {
    id: 47,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Abkhazian',
    resource: 'languageConstants/1046',
  },
  {
    id: 48,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Afrikaans',
    resource: 'languageConstants/1047',
  },
  {
    id: 49,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Amharic',
    resource: 'languageConstants/1048',
  },
  {
    id: 50,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Assamese',
    resource: 'languageConstants/1049',
  },
  {
    id: 51,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Aymara',
    resource: 'languageConstants/1050',
  },
  {
    id: 52,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Azerbaijani',
    resource: 'languageConstants/1051',
  },
  {
    id: 53,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Bashkir',
    resource: 'languageConstants/1052',
  },
  {
    id: 54,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Belarusian',
    resource: 'languageConstants/1053',
  },
  {
    id: 55,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Bihari',
    resource: 'languageConstants/1054',
  },
  {
    id: 56,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Bislama',
    resource: 'languageConstants/1055',
  },
  {
    id: 57,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Bengali',
    resource: 'languageConstants/1056',
  },
  {
    id: 58,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tibetan',
    resource: 'languageConstants/1057',
  },
  {
    id: 59,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Breton',
    resource: 'languageConstants/1058',
  },
  {
    id: 60,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Corsican',
    resource: 'languageConstants/1059',
  },
  {
    id: 61,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Welsh',
    resource: 'languageConstants/1060',
  },
  {
    id: 62,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Norwegian Nynorsk',
    resource: 'languageConstants/1061',
  },
  {
    id: 63,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Esperanto',
    resource: 'languageConstants/1062',
  },
  {
    id: 64,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Basque',
    resource: 'languageConstants/1063',
  },
  {
    id: 65,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Persian',
    resource: 'languageConstants/1064',
  },
  {
    id: 66,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Fijian',
    resource: 'languageConstants/1065',
  },
  {
    id: 67,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Faroese',
    resource: 'languageConstants/1066',
  },
  {
    id: 68,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Western Frisian',
    resource: 'languageConstants/1067',
  },
  {
    id: 69,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Irish',
    resource: 'languageConstants/1068',
  },
  {
    id: 70,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Scottish Gaelic',
    resource: 'languageConstants/1069',
  },
  {
    id: 71,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Galician',
    resource: 'languageConstants/1070',
  },
  {
    id: 72,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Guarani',
    resource: 'languageConstants/1071',
  },
  {
    id: 73,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Gujarati',
    resource: 'languageConstants/1072',
  },
  {
    id: 74,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Manx',
    resource: 'languageConstants/1073',
  },
  {
    id: 75,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Hausa',
    resource: 'languageConstants/1074',
  },
  {
    id: 76,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Bosnian',
    resource: 'languageConstants/1075',
  },
  {
    id: 77,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Armenian',
    resource: 'languageConstants/1076',
  },
  {
    id: 78,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Interlingua',
    resource: 'languageConstants/1077',
  },
  {
    id: 79,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Interlingue',
    resource: 'languageConstants/1078',
  },
  {
    id: 80,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Inupiaq',
    resource: 'languageConstants/1079',
  },
  {
    id: 81,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Inuktitut',
    resource: 'languageConstants/1080',
  },
  {
    id: 82,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Javanese',
    resource: 'languageConstants/1081',
  },
  {
    id: 83,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Georgian',
    resource: 'languageConstants/1082',
  },
  {
    id: 84,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Kazakh',
    resource: 'languageConstants/1083',
  },
  {
    id: 85,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Greenlandic',
    resource: 'languageConstants/1084',
  },
  {
    id: 86,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Khmer',
    resource: 'languageConstants/1085',
  },
  {
    id: 87,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Kannada',
    resource: 'languageConstants/1086',
  },
  {
    id: 88,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Kashmiri',
    resource: 'languageConstants/1087',
  },
  {
    id: 89,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Kurdish',
    resource: 'languageConstants/1088',
  },
  {
    id: 90,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Cornish',
    resource: 'languageConstants/1089',
  },
  {
    id: 91,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Kirghiz',
    resource: 'languageConstants/1090',
  },
  {
    id: 92,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Latin',
    resource: 'languageConstants/1091',
  },
  {
    id: 93,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Luxembourgish',
    resource: 'languageConstants/1092',
  },
  {
    id: 94,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Lingala',
    resource: 'languageConstants/1093',
  },
  {
    id: 95,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Lao',
    resource: 'languageConstants/1094',
  },
  {
    id: 96,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Malagasy',
    resource: 'languageConstants/1095',
  },
  {
    id: 97,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Maori',
    resource: 'languageConstants/1096',
  },
  {
    id: 98,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Macedonian',
    resource: 'languageConstants/1097',
  },
  {
    id: 99,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Malayalam',
    resource: 'languageConstants/1098',
  },
  {
    id: 100,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Mongolian',
    resource: 'languageConstants/1099',
  },
  {
    id: 101,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Moldavian',
    resource: 'languageConstants/1100',
  },
  {
    id: 102,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Marathi',
    resource: 'languageConstants/1101',
  },
  {
    id: 103,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Malay',
    resource: 'languageConstants/1102',
  },
  {
    id: 104,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Maltese',
    resource: 'languageConstants/1103',
  },
  {
    id: 105,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Burmese',
    resource: 'languageConstants/1104',
  },
  {
    id: 106,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Nauru',
    resource: 'languageConstants/1105',
  },
  {
    id: 107,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Nepali',
    resource: 'languageConstants/1106',
  },
  {
    id: 108,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Occitan',
    resource: 'languageConstants/1107',
  },
  {
    id: 109,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: '(Afan) Oromo',
    resource: 'languageConstants/1108',
  },
  {
    id: 110,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Oriya',
    resource: 'languageConstants/1109',
  },
  {
    id: 111,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Punjabi',
    resource: 'languageConstants/1110',
  },
  {
    id: 112,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Pushto',
    resource: 'languageConstants/1111',
  },
  {
    id: 113,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Quechua',
    resource: 'languageConstants/1112',
  },
  {
    id: 114,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Raeto-Romance',
    resource: 'languageConstants/1113',
  },
  {
    id: 115,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Rundi',
    resource: 'languageConstants/1114',
  },
  {
    id: 116,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Kinyarwanda',
    resource: 'languageConstants/1115',
  },
  {
    id: 117,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Sanskrit',
    resource: 'languageConstants/1116',
  },
  {
    id: 118,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Sindhi',
    resource: 'languageConstants/1117',
  },
  {
    id: 119,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Northern S�mi',
    resource: 'languageConstants/1118',
  },
  {
    id: 120,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Sango',
    resource: 'languageConstants/1119',
  },
  {
    id: 121,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Zulu',
    resource: 'languageConstants/1120',
  },
  {
    id: 122,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Sinhalese',
    resource: 'languageConstants/1121',
  },
  {
    id: 123,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Samoan',
    resource: 'languageConstants/1122',
  },
  {
    id: 124,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Shona',
    resource: 'languageConstants/1123',
  },
  {
    id: 125,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Somali',
    resource: 'languageConstants/1124',
  },
  {
    id: 126,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Albanian',
    resource: 'languageConstants/1125',
  },
  {
    id: 127,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Swati',
    resource: 'languageConstants/1126',
  },
  {
    id: 128,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Sotho',
    resource: 'languageConstants/1127',
  },
  {
    id: 129,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Sundanese',
    resource: 'languageConstants/1128',
  },
  {
    id: 130,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Swahili',
    resource: 'languageConstants/1129',
  },
  {
    id: 131,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tamil',
    resource: 'languageConstants/1130',
  },
  {
    id: 132,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Telugu',
    resource: 'languageConstants/1131',
  },
  {
    id: 133,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tajik',
    resource: 'languageConstants/1132',
  },
  {
    id: 134,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tigrinya',
    resource: 'languageConstants/1133',
  },
  {
    id: 135,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Turkmen',
    resource: 'languageConstants/1134',
  },
  {
    id: 136,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tswana',
    resource: 'languageConstants/1135',
  },
  {
    id: 137,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tonga',
    resource: 'languageConstants/1136',
  },
  {
    id: 138,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tsonga',
    resource: 'languageConstants/1137',
  },
  {
    id: 139,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Tatar',
    resource: 'languageConstants/1138',
  },
  {
    id: 140,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Twi',
    resource: 'languageConstants/1139',
  },
  {
    id: 141,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Uighur',
    resource: 'languageConstants/1140',
  },
  {
    id: 142,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Uzbek',
    resource: 'languageConstants/1141',
  },
  {
    id: 143,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Volap�k',
    resource: 'languageConstants/1142',
  },
  {
    id: 144,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Wolof',
    resource: 'languageConstants/1143',
  },
  {
    id: 145,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Xhosa',
    resource: 'languageConstants/1144',
  },
  {
    id: 146,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Yiddish',
    resource: 'languageConstants/1145',
  },
  {
    id: 147,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Yoruba',
    resource: 'languageConstants/1146',
  },
  {
    id: 148,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Zhuang',
    resource: 'languageConstants/1147',
  },
  //   {
  //     id: 149,
  //     created_at: '2025-05-19T09:29:31.000000Z',
  //     updated_at: '2025-05-19T09:29:31.000000Z',
  //     name: 'English (Australia)',
  //     resource: 'languageConstants/1148',
  //   },
  {
    id: 150,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Portuguese (Portugal)',
    resource: 'languageConstants/1149',
  },
  {
    id: 151,
    created_at: '2025-05-19T09:29:31.000000Z',
    updated_at: '2025-05-19T09:29:31.000000Z',
    name: 'Chinese (Hong Kong SAR)',
    resource: 'languageConstants/1150',
  },
];

export const langList = JSON.parse(JSON.stringify(langListJSON));
